<script>
// import { SimpleBar } from "simplebar-vue3";

import { authComputed } from "@/state/helpers";
import { mapGetters } from "vuex";
/**
 * Nav-bar Component
 */
export default {
	data() {
		return {
			lang: "en",
			text: null,
			flag: null,
			value: null,
			isDarkMode: localStorage.getItem('theme') === 'dark',
			languages: [
				{
					flag: require("@/assets/images/flags/us.jpg"),
					language: "en",
					title: "English",
				},
				{
					flag: require("@/assets/images/flags/french.jpg"),
					language: "fr",
					title: "French",
				},
				{
					flag: require("@/assets/images/flags/spain.jpg"),
					language: "es",
					title: "Spanish",
				},
				{
					flag: require("@/assets/images/flags/chaina.png"),
					language: "zh",
					title: "Chinese",
				},
				{
					flag: require("@/assets/images/flags/arabic.png"),
					language: "ar",
					title: "Arabic",
				},
			],
		};
	},
	mounted() {
		this.darkModeFunction();
	},
	watch: {
		$route() {
			this.darkModeFunction(); // Call the method whenever the route changes
		}
	},
	methods: {
		toggleDarkMode() {
			this.isDarkMode = !this.isDarkMode;
			this.darkModeFunction();
		},
		darkModeFunction() {
			console.log('toggled');
			const body = document.body;
			const side = document.querySelector('.vertical-menu');
			const topBar = document.querySelector('.navbar-header');
			const brandBox = document.querySelector('.navbar-brand-box');
			const card = document.getElementsByClassName('card');
			const sideTexts = document.querySelectorAll('#sidebar-menu ul li a');
			const sideTextsIcon = document.querySelectorAll('#sidebar-menu ul li a i');
			const th = document.querySelectorAll('thead .bg-light th');
			const tbody = document.querySelectorAll('tbody');
			const inputfield = document.querySelectorAll('.form-control');
			const title = document.querySelectorAll('.page-title-box h4');
			const cardBodyH3 = document.querySelectorAll('.card-body h3, .card-body h4');
			const allElements = document.querySelectorAll('table, th, td, tr');
			const borders = document.querySelectorAll('.custom-border');
			const modal = document.querySelectorAll('.modal-content, .modal-header h5');
			const swal = document.querySelectorAll('.swal2-container.swal2-center > .swal2-popup');
			const pagination = document.querySelectorAll('.page-item,.page-link');
			if (this.isDarkMode) {
				body.classList.add('dark-mode');
				side.classList.add('dark-mode-top-side');
				topBar.classList.add('dark-mode-top-side');
				brandBox.classList.add('dark-mode-top-side');
				body.classList.add('text-shadow');
				// pagination.forEach(element => {
				// 	element.style.backgroundColor = '#2e2e2e';
				// 	element.style.border = 'none';
				// 	element.style.color = 'white';
				// });
				modal.forEach(element => {
					element.style.backgroundColor = '#2e2e2e';
					element.style.border = 'none';
					element.style.color = 'white'
				});
				swal.forEach(element => {
					element.style.backgroundColor = '#2e2e2e';
					element.style.border = 'none';
					element.style.color = 'white'
				});
				// borders.forEach(element => {
				// 	element.style.border = 'none';
				// });
				// allElements.forEach(element => {
				// 	element.style.border = '1px solid #464040';
				// });
				// cardBodyH3.forEach(t => {
				// 	t.style.color = '#DBDBDB';
				// });
				title.forEach(t => {
					t.style.color = '#DBDBDB';
				});
				// inputfield.forEach(t => {
				// 	if (t.disabled) {
				// 		t.style.backgroundColor = 'black';
				// 		t.style.border = '#2c2828';
				// 		t.style.color = 'white';
				// 	} else {
				// 		t.style.backgroundColor = 'rgb(20, 19, 19)';
				// 		t.style.border = '#2c2828';
				// 		t.style.color = 'white';
				// 	}
				// });
				// tbody.forEach(t => {
				// 	t.style.background = '#1a1a1a';
				// 	t.style.color = '#DBDBDB';
				// 	t.style.borderTop = 'none';
				// });
				// th.forEach(t => {
				// 	t.style.backgroundColor = '#353535';
				// 	t.style.color = '#DBDBDB';
				// 	t.style.borderTop = 'none';
				// });
				sideTextsIcon.forEach(sideText => {
					sideText.style.color = '#19c7e6';
				});
				sideTexts.forEach(sideText => {
					sideText.style.color = '#19c7e6';
				});
				// for (let i = 0; i < card.length; i++) {
				// 	card[i].classList.add('card-dark');
				// }
				localStorage.setItem('theme', 'dark');
			} else {
				body.classList.remove('dark-mode');
				side.classList.remove('dark-mode-top-side');
				topBar.classList.remove('dark-mode-top-side');
				brandBox.classList.remove('dark-mode-top-side');
				body.classList.remove('text-shadow');
				pagination.forEach(element => {
					element.style.backgroundColor = '#F0F4F5';
					element.style.color = '#74788d'
				});
				borders.forEach(element => {
					element.style.border = '1px solid rgb(239, 242, 247)';
				});
				allElements.forEach(element => {
					element.style.border = '1px solid #eff2f7';
				});
				cardBodyH3.forEach(t => {
					t.style.color = '#3f3f3f';
				});
				title.forEach(t => {
					t.style.color = '#3f3f3f';
				});
				inputfield.forEach(t => {
					if (t.disabled) {
						// t.style.backgroundColor = 'rgb(207 207 207)';
					} else {
						t.style.backgroundColor = 'white';
						t.style.border = '1px solid #ced4da';
						t.style.color = 'grey';
					}
				});
				tbody.forEach(t => {
					t.style.color = '#495057';
					t.style.background = '#fff';
				});
				th.forEach(t => {
					t.style.backgroundColor = '#EFF2F7';
					t.style.color = '#495057';
				});
				sideTextsIcon.forEach(sideText => {
					sideText.style.color = '#353535';
				});
				sideTexts.forEach(sideText => {
					sideText.style.color = '#353535';
				});
				for (let i = 0; i < card.length; i++) {
					card[i].classList.remove('card-dark');
				}
				localStorage.setItem('theme', 'light');
			}
		},
		toggleMenu() {
			this.$parent.toggleMenu();
		},
		toggleRightSidebar() {
			this.$parent.toggleRightSidebar();
		},
		initFullScreen() {
			document.body.classList.toggle("fullscreen-enable");
			if (
				!document.fullscreenElement &&
				/* alternative standard method */ !document.mozFullScreenElement &&
				!document.webkitFullscreenElement
			) {
				// current working methods
				if (document.documentElement.requestFullscreen) {
					document.documentElement.requestFullscreen();
				} else if (document.documentElement.mozRequestFullScreen) {
					document.documentElement.mozRequestFullScreen();
				} else if (document.documentElement.webkitRequestFullscreen) {
					document.documentElement.webkitRequestFullscreen(
						Element.ALLOW_KEYBOARD_INPUT
					);
				}
			} else {
				if (document.cancelFullScreen) {
					document.cancelFullScreen();
				} else if (document.mozCancelFullScreen) {
					document.mozCancelFullScreen();
				} else if (document.webkitCancelFullScreen) {
					document.webkitCancelFullScreen();
				}
			}
		},
		logoutUser() {
			this.$store.dispatch("auth/logoutUser").then(() => {
			});
		},
		callFunction() {
			console.log('call')
		}
	},
	computed: {
		...authComputed,
		...mapGetters("auth", ["profile"]),
	},
};
</script>

<template>
	<header id="page-topbar">
		<div class="navbar-header">
			<div class="d-flex">
				<!-- LOGO -->
				<div class="navbar-brand-box">
					<router-link to="/" class="logo logo-dark">
						<span class="logo-sm">
							<img src="@/assets/images/logo.svg" alt height="22" />
						</span>
						<span class="logo-lg">
							<img src="@/assets/images/logo-dark.png" alt height="17" />
						</span>
					</router-link>

					<router-link to="/" class="logo logo-light">
						<span class="logo-sm">
							<img class="ms-n1" src="@/assets/images/logo-gapp.png" alt height="30" />
						</span>
						<span class="logo-lg">
							<img v-if="isDarkMode" src="@/assets/images/Gapp-logo.png" alt height="40" />
							<img v-else src="@/assets/images/Gapp-logo-dark.png" alt height="40" />
						</span>
					</router-link>
				</div>
				<button id="vertical-menu-btn" type="button"
					class="btn btn-sm px-3 font-size-16 header-item text-secondary" @click="toggleMenu">
					<i class="fa fa-fw fa-bars"></i>
				</button>
			</div>
			<div class="d-flex">

				<i @click="toggleDarkMode" class="fs-3 mt-4 me-3 cursor-pointer"
					:class="isDarkMode ? 'bx bx-sun' : 'bx bx-moon'"></i>
				<b-dropdown right variant="black" toggle-class="header-item" menu-class="dropdown-menu-end">
					<template v-slot:button-content>
						<!-- <img
							class="rounded-circle header-profile-user"
							src="@/assets/images/users/avatar-1.jpg"
							alt="Header Avatar"
						/> -->
						<span class="d-inline-block mt-2">
							<div v-if="profile">
								<h6 class="text-secondary text-uppercase mb-0">{{ profile.username }}</h6>
								<p class="text-color">{{ profile.role }}</p>
							</div>
							<div v-else>User</div>
						</span>
						<i class="mdi mdi-chevron-down d-inline-block text-dark"></i>
					</template>
					<button @click="logoutUser()" class="dropdown-item text-danger">
						<i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
						Logout
					</button>
				</b-dropdown>
			</div>
		</div>
	</header>
</template>
